import {
  NEXT_PAGE,
  PREVIOUS_PAGE,
  SELECT_CATEGORY,
  SET_PAGE,
  TOGGLE_MODAL
} from './types';

export const nextPage = () => ({ type: NEXT_PAGE });
export const previousPage = () => ({ type: PREVIOUS_PAGE });
export const selectCategory = (category) => ({
  type: SELECT_CATEGORY,
  category
});
export const setPage = (pageNum) => ({ type: SET_PAGE, pageNum });
export const toggleModal = (showModal) => ({ type: TOGGLE_MODAL, showModal });
